/**
 * Published games, played by guests - no login (backend routers/game_builder.py play_router, services/game_builder/publish.py).
 */
import axios from 'axios';

const BASE = `${process.env.REACT_APP_API_URL}/api/play`;

const messageOf = (error) => {
  if (error.response?.status === 404) return error.response.data?.detail || "This simulation isn't available.";
  if (!error.response) return "Can't reach the server. Check your connection and try again.";
  return 'Something went wrong. Try again in a moment.';
};

/** {version, title, spec} - the latest published version of the game behind a share link. */
export const getPublishedGame = async (token) => {
  try {
    return (await axios.get(`${BASE}/${encodeURIComponent(token)}`, { timeout: 30000 })).data;
  } catch (error) {
    throw new Error(messageOf(error));
  }
};

/** One play, when it ends. Never in the player's way: a failure to send is only logged. */
export const sendRun = async (token, run) => {
  try {
    await axios.post(`${BASE}/${encodeURIComponent(token)}/runs`, run, { timeout: 15000 });
  } catch (error) {
    console.warn('Could not save this play:', messageOf(error));
  }
};
